// @ts-nocheck
import React, {FC, useContext, useEffect, useState} from "react";
import {Box, Card, Flex, ScrollArea} from "@mantine/core";
import SCMessageBarContext from "@/utils/contexts/sc-message-bar-context";
import * as Enums from "@/utils/enums";
import Storage from "@/utils/storage";
import Helper from "@/utils/helper";
import Router from "next/router";
import Breadcrumbs from "@/components/breadcrumbs";
import constants from "@/utils/constants";
import AppointmentsList from "@/PageComponents/Appointment/AppointmentsList";
import { createFileRoute } from '@tanstack/react-router'




const AppointmentPage: FC = () => {
    const messageBarContext = useContext(SCMessageBarContext);
    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    // Prevent body/page scrollbars flicker while using scheduler popovers
    useEffect(() => {
        if (typeof document === 'undefined') return;
        const prevBodyOverflowX = document.body.style.overflowX;
        const prevBodyOverflowY = document.body.style.overflowY;

        // Hide body scrollbars; scrolling happens inside the page container below
        document.body.style.overflowX = 'hidden';
        document.body.style.overflowY = 'hidden';

        return () => {
            document.body.style.overflowX = prevBodyOverflowX;
            document.body.style.overflowY = prevBodyOverflowY;
        };
    }, []);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus])

    return (
        <>
            <Box
                mt={'var(--mantine-spacing-sm)'}
                px={'var(--mantine-spacing-md)'}
                mb={0}
                pb={0}
                style={(theme: any) => ({borderBottom: `${theme.colors.gray[2]} 2px solid`})}
            >
                <Box my={'var(--mantine-spacing-md)'}>
                    <Breadcrumbs currPage={{
                        text: 'Appointment',
                        link: `/appointment/`,
                        type: 'list'
                    }}/>
                </Box>

            </Box>
            <Box
                h={`calc(100vh - 90px${((messageBarContext as any)?.isActive ? ` - ${constants.messageBarMargin}px` : "")})`}
                style={(theme: any) => ({
                    backgroundColor: theme.colors.gray[1],
                    overflowY: 'auto'
                })}
                p={'var(--mantine-spacing-xs)'}
                py={4}
                pb={constants.chatWidgetSafeArea}
            >
                <Card
                    style={{
                        backgroundColor: 'white'
                    }}
                    p={'var(--mantine-spacing-md)'}
                    radius={'md'}
                >
                    <AppointmentsList />
                </Card>

            </Box>

        </>
    )
}

export default AppointmentPage;

export const Route = createFileRoute('/_authenticated/appointment')({ component: AppointmentPage })
